
















































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import firebase from 'firebase/app'

//import { VueYoutube } from "vue-youtube";

//Vue.use(VueYoutube);

interface Category {
  text: string,
  value: string,
  players: Array<Player>,
}

interface Player {
  text: string,
  value: string,
  albums: Array<Album>,
}

interface Album {
  text: string,
  value: string,
  //albums: Array<Album>,
}

interface Document2 {
  docId: string, // Category Name
  players: Array<string>,
  //category2: Category2,
  category3: Category3,
}

interface Category2 {
  name: String,
  players: Array<string>,
}

interface Category3 {
  name: String,
  players: Array<Player2>,
}

interface Player2 {
  name: String,
  albums: Array<string>,
}

interface Document {
  docId: string,
  content: Content
}

interface Content {
  //docId: string,
  name: string,
  videoId: string,
  explanations: Array<string>,
  kubun: string,
  category: string,
  player: string,
  album: string,
  createdAt: string, //firebase.firestore.Timestamp, //firebase.firestore.FieldValue.serverTimestamp(),
  updatedAt: string, //firebase.firestore.Timestamp, //firebase.firestore.FieldValue.serverTimestamp(),
}

interface User {
  name: string,
  password: string,
}

@Component
export default class EnglishGrammarComponent extends Vue {
	@Prop()
	private msg!: string;
	
	private categoryIndex: number = 0;
	private categoryIndex2: number = 0;
	private categoryIndex3: number = 0;
	private playerIndex = 0
	private playerIndex2: number = 0;
	private playerIndex3: number = 0;
	private albumIndex: number = 0;
	private albumIndex2: number = 0;
	private albumIndex3: number = 0;
	private itemIndex: number = 0;

	private selectedKubun: string = "英文法"; // 固定
	private selectedCategory: string = "";
	private selectedPlayer: string = "";
	private selectedAlbum: string = "";

	// ここから本番データ		
	private document2s: Array<Document2> = []
	private menuCategoryIndex: number = 0
	private menuPlayerIndex: number = 0
	private menuAlbumIndex: number = 0
	
	
	private documents: Array<Document> = []
	private documentIndex: number = 0
	
	private docId: string = "??"
	private name: string = "name"
	private videoId: string = "8bAyTNXKtj8"
	private explanations: string = "explanations"
	private kubun: string = this.selectedKubun
	private category: string = "category"
	private player: string = "player"
	private album: string = "album"
	private createdAt: string = "createdAt"
	private updatedAt: string = "updatedAt"
	private addResult: string = "result_add"
	private updateResult: string = "result_update"
	
	private user: User = {name:"", password:""}
	private query_document: Document = {docId:"", content: {name:"", videoId:"", explanations:[""], kubun:"youtube", category:"", player:"", album:"", createdAt: "", updatedAt: ""}}
	private add_document: Document = {docId:"", content: {name:"", videoId:"", explanations:[""], kubun:"youtube", category:"", player:"", album:"", createdAt: "", updatedAt: ""}}
	
	private playVideo(): void {
		//const player =this.$refs.youtube.player.playVideo()
		//this.player.playVideo()
	}
	
	private ready() {
		window.console.log("ready() 1.")
		/*
		const youtubePlayer = this.$refs.youtube.player
		youtubePlayer.resize = true
		window.console.log("ready() 2.width: " + youtubePlayer.width)
		youtubePlayer.fitParent = true
		youtubePlayer.width = 1280
		youtubePlayer.height= 720
		window.console.log("ready() 3.width: " + youtubePlayer.width)
		youtubePlayer.resize = true
		youtubePlayer.playVideo()
		*/
	} 

	private click_add(): void {
		//window.console.log("click_add() 1.name: " + this.user.name + ", password: " + this.user.password)
		//this.queryContentsProc()
		window.console.log("click() 1.name: " + this.add_document.content.name)
		window.console.log("click() 2.videoId: " + this.add_document.content.videoId)
		window.console.log("click() 3.kubun: " + this.add_document.content.kubun)
		window.console.log("click() 4.category: " + this.add_document.content.category)
		window.console.log("click() 5.player: " + this.add_document.content.player)
		window.console.log("click() 6.album: " + this.add_document.content.album)
		var message = ""
		if (this.add_document.content.name == "") {
			alert("nameが空白です")
			return
		}
		if (this.add_document.content.videoId == "") {
			alert("videoIdが空白です")
			return
		}
		if (this.add_document.content.kubun == "") {
			alert("kubunが空白です")
			return
		}
		if (this.add_document.content.category == "") {
			alert("categoryが空白です")
			return
		}
		if (this.add_document.content.player == "") {
			alert("playerが空白です")
			return
		}
		if (this.add_document.content.album == "") {
			alert("albumが空白です")
			return
		}
		var message = "name: " + this.add_document.content.name
		message += "\nvideoId: " + this.add_document.content.videoId
		message += "\nkubun: " + this.add_document.content.kubun
		message += "\ncategory: " + this.add_document.content.category
		message += "\nplayer: " + this.add_document.content.player
		message += "\nalbum: " + this.add_document.content.album
		message += "\n\nの内容で登録しますか？"
		const ans = confirm(message)
		if (ans) {
			this.addDocument()
			//alert("登録機能は未サポートです")
		}
	}
	
	private click_update(): void {
		//window.console.log("click_edit() 1.name: " + this.user.name + ", password: " + this.user.password)
		//this.queryContentsProc()
		window.console.log("click_update() 1.name: " + this.query_document.content.name)
		window.console.log("click_update() 2.videoId: " + this.query_document.content.videoId)
		window.console.log("click_update() 3.kubun: " + this.query_document.content.kubun)
		window.console.log("click_update() 4.category: " + this.query_document.content.category)
		window.console.log("click_update() 5.player: " + this.query_document.content.player)
		window.console.log("click_update() 6.album: " + this.query_document.content.album)
		var message = ""
		if (this.query_document.content.name == "") {
			alert("nameが空白です")
			return
		}
		if (this.query_document.content.videoId == "") {
			alert("videoIdが空白です")
			return
		}
		if (this.query_document.content.kubun == "") {
			alert("kubunが空白です")
			return
		}
		if (this.query_document.content.category == "") {
			alert("categoryが空白です")
			return
		}
		if (this.query_document.content.player == "") {
			alert("playerが空白です")
			return
		}
		if (this.query_document.content.album == "") {
			alert("albumが空白です")
			return
		}
		var message = "name: " + this.query_document.content.name
		//this.query_document.content.createdAt = this.getStringFromDate(new Date())

		message += "\nvideoId: " + this.query_document.content.videoId
		message += "\nkubun: " + this.query_document.content.kubun
		message += "\ncategory: " + this.query_document.content.category
		message += "\nplayer: " + this.query_document.content.player
		message += "\nalbum: " + this.query_document.content.album
		message += "\ncreatedAt: " + this.query_document.content.createdAt
		message += "\nupdatedAt: " + this.query_document.content.updatedAt
		message += "\n\nの内容で編集しますか？"
		const ans = confirm(message)
		if (ans) {
			this.updateDocument()
			//alert("編集機能は未サポートです")
		}
	}
	
	// 「firestore」に新しいドキュメントを登録する
	public addDocument() {
		window.console.log("addDocument() 1.")
		const admin = require("firebase-admin")
		//this.add_document.content.createdAt = admin.firestore.FieldValue.serverTimestamp()
		this.add_document.content.createdAt = this.getStringFromDate(new Date())
		//this.add_document.content.updatedAt = admin.firestore.FieldValue.serverTimestamp()
		this.add_document.content.updatedAt = this.getStringFromDate(new Date())
		const contentsRef = this.$firestore.collection('contents')
		contentsRef.add(this.add_document.content)
		.then((docRef: any) => {
			const message = "Document written with ID: " + docRef.id
			this.addResult = message
			window.console.log("addDocument() 2." + message)
			this.add_document.content.name = ""
			this.add_document.content.videoId = ""
			this.add_document.content.album = ""
		})
		.catch((error: any) => {
			window.console.log("addDocument() 3.Error adding document: " + error)
		})
	}

	// 「firestore」に既存のドキュメントを更新する
	public updateDocument() {
		///*
		window.console.log("updateDocument() 1.createdAt: " + this.query_document.content.createdAt)
		//const admin = require("firebase-admin")
		//const serviceAccount = require("../firebase/helloapp-87353-firebase-adminsdk-bib6q-00edf42ca1.json");
		//admin.initializeApp({credential: admin.credential.cert(serviceAccount)})
		if (this.query_document.content.createdAt == undefined || this.query_document.content.createdAt == "") {
			window.console.log("updateDocument() 2.createdAt: " + this.query_document.content.createdAt)
			//this.query_document.content.createdAt = admin.firestore.FieldValue.serverTimestamp()
			//this.query_document.content.createdAt = this.$firestore.FieldValue.serverTimestamp()
			this.query_document.content.createdAt = this.getStringFromDate(new Date())
			window.console.log("updateDocument() 3.createdAt: " + this.query_document.content.createdAt)
		}
		//this.query_document.content.createdAt = this.getStringFromDate(new Date())
		//this.query_document.content.updatedAt = admin.firestore.FieldValue.serverTimestamp()
		//this.query_document.content.updatedAt = this.$firestore.FieldValue.serverTimestamp()
		//this.query_document.content.createdAt = this.getStringFromDate(new Date())
		this.query_document.content.updatedAt = this.getStringFromDate(new Date())
		//*/
		const contentsRef = this.$firestore.collection('contents')
		contentsRef.doc(this.query_document.docId).update(this.query_document.content)
		.then(() => {
			const message = "Document updated with ID: " + this.query_document.docId
			this.updateResult = message
			window.console.log("updateDocument() 4." + message)
			//this.add_document.content.name = ""
			//this.add_document.content.videoId = ""
			//this.add_document.content.album = ""
		})
		.catch((error: any) => {
			window.console.log("updateDocument() 5.Error adding document: " + error)
		})
		//*/
	}

	//日付から文字列に変換する関数
	private getStringFromDate(date: Date): string {
		//var today: Date = Date()
		var year_str = date.getFullYear();
		//月だけ+1すること
		var month_str = 1 + date.getMonth();
		var day_str = date.getDate();
		var hour_str = date.getHours();
		var minute_str = date.getMinutes();
		var second_str = date.getSeconds();


		var format_str = "YYYY-MM-DD hh:mm:ss";
		format_str = format_str.replace(/YYYY/g, year_str.toString());
		format_str = format_str.replace(/MM/g, month_str.toString());
		format_str = format_str.replace(/DD/g, day_str.toString());
		format_str = format_str.replace(/hh/g, hour_str.toString());
		format_str = format_str.replace(/mm/g, minute_str.toString());
		format_str = format_str.replace(/ss/g, second_str.toString());

		return format_str;
	}
	
	// 試験用：「firestore」に「youtube」コレクションのドキュメントを検索する
	private testQueryYoutubeProc() {
		window.console.log("testQueryYoutubeProc() 1.")
		const contentsRef = this.$firestore.collection('英文法') // ①
		contentsRef
			// 「youtube」コレクションを読む
			.get().then((snapShot: any) => { // ②
				snapShot.forEach ((doc: any) => { // ③
					// ドキュメント単位に処理
					window.console.log("testQueryYoutubeProc() 2.doc.id: " + doc.id)
					var data = doc.data() // ④
					window.console.log("testQueryYoutubeProc() 3.data.players: " + data.players)
					data.players.forEach((player: string) => {
						window.console.log("testQueryYoutubeProc() 4.player: " + player)
						// 演奏者単位にコレクションを読む
						const contentsRef2 = contentsRef.doc(doc.id).collection(player)
						contentsRef2.get().then((snapShot: any) => {  // サブコレクションを読む
							snapShot.forEach ((doc2: any) => { // ③
								var data2 = doc2.data() // ④
								window.console.log("testQueryYoutubeProc() 5.data2.albums: " + data2.albums)
							})
						})
					})
				})
			})
		//})
	}
	
	// 「firestore」に「英文法」コレクションのドキュメントを検索する
	private queryMenuProc() {
		//window.console.log("queryMenuProc() 1.collectionName: " + collectionName)
		//window.console.log("queryMenuProc() 2.selectedCategory: " + this.selectedCategory)
		//window.console.log("queryMenuProc() 3.selectedPlayer: " + this.selectedPlayer)
		//window.console.log("queryMenuProc() 4.selectedAlbum: " + this.selectedAlbum)
		this.document2s.splice(0)
		const contentsRef = this.$firestore.collection(this.selectedKubun) // ①
		contentsRef
			// 「youtube」コレクションを読む
			.get().then((snapShot: any) => { // ②
				snapShot.forEach ((doc: any) => { // ③
					// ドキュメント単位に処理
					window.console.log("queryMenuProc() 3.doc.id: " + doc.id)
					var data = doc.data() // ④
					var document2: Document2 = {docId:doc.id, players: data.players, category3: {name:doc.id, players: []}}
					this.document2s.push(document2)
				}) // end of forEach
				// 次にサブコレクションを読む
				this.document2s.forEach((doc2: Document2) => {
					// 演奏者を調べる
					window.console.log("queryMenuProc() 11.doc2.docId: " + doc2.docId)
					if (this.selectedCategory == "") {
						this.selectedCategory = doc2.docId // this.document2s[this.menuCategoryIndex].docId
						window.console.log("queryMenuProc() 12.this.selectedCategory: " + this.selectedCategory)
					}
					if (this.query_document.content.category == "") {
						this.query_document.content.category = doc2.docId // this.document2s[this.menuCategoryIndex].docId
					}
					if (this.add_document.content.category == "") {
						this.add_document.content.category = doc2.docId // this.document2s[this.menuCategoryIndex].docId
					}
					
					window.console.log("queryMenuProc() 13.doc2.players: " + doc2.players)
					var player2s: Array<Player2> = []
					doc2.players.forEach((player: string) => {
						window.console.log("queryMenuProc() 14.player: " + player)
						if (this.selectedPlayer == "") {
							this.selectedPlayer = player // this.document2s[this.menuCategoryIndex].players[this.menuPlayerIndex]
							window.console.log("queryMenuProc() 14.this.selectedPlayer: " + this.selectedPlayer)
						}
						if (this.query_document.content.player == "") {
							this.query_document.content.player = player // this.document2s[this.menuCategoryIndex].docId
						}
						if (this.add_document.content.player == "") {
							this.add_document.content.player = player // this.document2s[this.menuCategoryIndex].docId
						}

						// 演奏者単位にコレクションを読む
						const contentsRef2 = contentsRef.doc(doc2.docId).collection(player)
						contentsRef2.get().then((snapShot: any) => {  // サブコレクションを読む
							snapShot.forEach ((doc2: any) => { // ③
								var data = doc2.data() // ④
								window.console.log("queryMenuProc() 16.doc2.id: " + doc2.id)
								window.console.log("queryMenuProc() 17.data.albums: " + data.albums)
								var player2: Player2 = {name: player, albums:data.albums }
								// 
								player2s.push(player2)
								if (this.selectedAlbum == "") {
									this.selectedAlbum = this.document2s[this.menuCategoryIndex].category3.players[this.menuPlayerIndex].albums[this.menuAlbumIndex] 
									window.console.log("queryMenuProc() 18.this.selectedAlbum: " + this.selectedAlbum)
								}
								if (this.query_document.content.album == "") {
									this.query_document.content.album = this.document2s[this.menuCategoryIndex].category3.players[this.menuPlayerIndex].albums[this.menuAlbumIndex]
								}
								if (this.add_document.content.album == "") {
									this.add_document.content.album = this.document2s[this.menuCategoryIndex].category3.players[this.menuPlayerIndex].albums[this.menuAlbumIndex]
								}
								
							}) // end of forEach
						}) // end of then
						.catch((error: any) => {
							window.console.log("queryMenuProc() 19.Error querying document: " + error)
						})
					})
					doc2.category3.players = player2s
				}) // end of Each
				window.console.log("queryContentsProc() 11.最初のコンテンツを表示する")
				// ソート処理を行う
				const sortedArray: Document2[] = this.document2s.sort((n1,n2) => {
				    if (n1.docId > n2.docId) {
				        return 1;
				    }
				    if (n1.docId < n2.docId) {
				        return -1;
				    }
				    return 0;
				});
			}) // end of then
			.catch((error: any) => {
				window.console.log("queryMenuProc() 19.Error querying document: " + error)
				//var document2: Document2 = {docId:"??", players: ["コンテンツは見つかりません"], category3: {name:"??", players: []}}
				//this.document2s.push(document2)
			})
			//this.firstContent()
			//})
		//})
		//window.console.log("queryMenuProc() 21." + this.$watanabe)
	} // end of queryMenuProc


	// 「firestore」に「contents」コレクションのドキュメントを検索する
	private queryContentsProc(collectionName: string) {
		window.console.log("queryContentsProc() 1.collectionName: " + collectionName)
		window.console.log("queryContentsProc() 2.selectedKubun: " + this.selectedKubun)
		window.console.log("queryContentsProc() 3.selectedCategory: " + this.selectedCategory)
		window.console.log("queryContentsProc() 4.selectedPlayer: " + this.selectedPlayer)
		window.console.log("queryContentsProc() 5.selectedAlbum: " + this.selectedAlbum)
		this.documents.splice(0)
		const contentsRef = this.$firestore.collection(collectionName) // ①
		contentsRef
			.where('kubun', '==', this.selectedKubun)
			.where('category', '==', this.selectedCategory)
			.where('player', '==', this.selectedPlayer)
			//.where('album', '==', this.selectedAlbum)
			.get().then((snapShot: any) => { // ②
				snapShot.forEach ((doc: any) => { // ③
					var data = doc.data() // ④
					window.console.log("queryContentsProc() 6.doc.id: " + doc.id)
					window.console.log("queryContentsProc() 7.name: " + data.name)
					window.console.log("queryContentsProc() 8.videoId: " + data.videoId)
					window.console.log("queryContentsProc() 9.kubun: " + data.kubun)
					window.console.log("queryContentsProc() 10.category: " + data.category)
					window.console.log("queryContentsProc() 11.player: " + data.player)
					window.console.log("queryContentsProc() 12.album: " + data.album)
					var document: Document = {docId:doc.id, content: {name:data.name, videoId:data.videoId, explanations:data.explanations, kubun:data.kubun, category:data.category, player:data.player, album:data.album, createdAt:data.createdAt, updatedAt:data.updatedAt}}
					this.documents.push(document)
					window.console.log("queryContentsProc() 13.document.docId: " + document.docId)
				}) // end of forEach
				window.console.log("queryContentsProc() 14.最初のコンテンツを表示する")
				// ソート処理を行う
				const sortedArray: Document[] = this.documents.sort((n1,n2) => {
				    if (n1.content.name > n2.content.name) {
				        return 1;
				    }
				    if (n1.content.name < n2.content.name) {
				        return -1;
				    }
				    return 0;
				});
				this.firstContent()
			}) // end of then
			.catch((error: any) => {
				window.console.log("queryContentsProc() 15.Error querying document: " + error)
				//var document: Document = {docId:"??", content: {name:"コンテンツは見つかりません。検索をしてください。", videoId:"mF5Qq2YheTg", kubun:"??", category:"??", player:"??", album:"??", createdAt:"??", updatedAt:"??"}}
				//this.documents.push(document)
				this.docId = "??"
				this.name = "コンテンツは見つかりません。検索をしてください。"
				this.videoId = "mF5Qq2YheTg"
				this.kubun = "??"
				this.category = "??"
				this.player = "??"
				this.album = "??"
				this.createdAt = "??"
				this.updatedAt = "??"

				this.firstContent()
				
			})
			//this.firstContent()
			//})
		//})
		//window.console.log("queryContentsProc() 16." + this.$watanabe)
	} // end of queryContentsProc

	private selectContent(index: number) {
		window.console.log("selectContent() 1.index: " + index)
		this.documentIndex = index
	    const document = this.documents[this.documentIndex]
		window.console.log("firstContent() 2.document.content.name: " + document.content.name)
		this.docId = document.docId
		this.name = document.content.name
		this.videoId = document.content.videoId
		this.kubun = document.content.kubun
		this.category = document.content.category
		this.player = document.content.player
		this.album = document.content.album
		this.createdAt = document.content.createdAt
		this.updatedAt = document.content.updatedAt
		
		this.query_document.docId = document.docId
		this.query_document.content.name = document.content.name
		this.query_document.content.videoId = document.content.videoId
		this.query_document.content.kubun = document.content.kubun
		this.query_document.content.category = document.content.category
		this.query_document.content.player = document.content.player
		this.query_document.content.album = document.content.album
		this.query_document.content.createdAt = document.content.createdAt
		this.query_document.content.updatedAt = document.content.updatedAt

		this.changeSelectedCategory3()
	}
	
	private firstContent() {
		window.console.log("firstContent() 1.")
		if (this.documents.length > 0) {
			this.documentIndex = 0
		    var document = this.documents[this.documentIndex]
			window.console.log("firstContent() 2.document.content.name: " + document.content.name)
			this.docId = document.docId
			this.name = document.content.name
			this.videoId = document.content.videoId
			this.explanations = ""
			document.content.explanations.forEach((explanation: string) => {
				this.explanations += explanation + "\n"
			})
			this.kubun = document.content.kubun
			this.category = document.content.category
			this.player = document.content.player
			this.album = document.content.album
			this.createdAt = document.content.createdAt
			this.updatedAt = document.content.updatedAt
			
			this.query_document.docId = document.docId
			this.query_document.content.name = document.content.name			
			this.query_document.content.videoId = document.content.videoId
			document.content.explanations.forEach((explanation: string) => {
				this.query_document.content.explanations.push(explanation)
			})
			this.query_document.content.kubun = document.content.kubun
			this.query_document.content.category = document.content.category
			this.query_document.content.player = document.content.player
			this.query_document.content.album = document.content.album
			this.query_document.content.createdAt = document.content.createdAt
			this.query_document.content.updatedAt = document.content.updatedAt

			this.changeSelectedCategory3()
		}
	}

	private nextContent() {
		window.console.log("nextContent() 1.")
		if (this.documents.length > 0) {
			this.documentIndex++
			if (this.documentIndex >= this.documents.length) {
				this.documentIndex = 0
			}
		    var document = this.documents[this.documentIndex]
			window.console.log("firstContent() 2.document.content.name: " + document.content.name)
			this.docId = document.docId
			this.name = document.content.name
			this.videoId = document.content.videoId
			this.kubun = document.content.kubun
			this.category = document.content.category
			this.player = document.content.player
			this.album = document.content.album
			this.createdAt = document.content.createdAt
			this.updatedAt = document.content.updatedAt
			
			this.query_document.docId = document.docId
			this.query_document.content.name = document.content.name
			this.query_document.content.videoId = document.content.videoId
			this.query_document.content.kubun = document.content.kubun
			this.query_document.content.category = document.content.category
			this.query_document.content.player = document.content.player
			this.query_document.content.album = document.content.album
			this.query_document.content.createdAt = document.content.createdAt
			this.query_document.content.updatedAt = document.content.updatedAt
			
			this.changeSelectedCategory3()
		}
	}

	private previousContent() {
		window.console.log("previousContent() 1.")
		if (this.documents.length > 0) {
			this.documentIndex--
			if (this.documentIndex < 0) {
				this.documentIndex = this.documents.length - 1
			}
		    var document = this.documents[this.documentIndex]
			window.console.log("previousContent() 2.document.content.name: " + document.content.name)
			this.docId = document.docId
			this.name = document.content.name
			this.videoId = document.content.videoId
			this.kubun = document.content.kubun
			this.category = document.content.category
			this.player = document.content.player
			this.album = document.content.album
			this.createdAt = document.content.createdAt
			this.updatedAt = document.content.updatedAt
			
			this.query_document.docId = document.docId
			this.query_document.content.name = document.content.name
			this.query_document.content.videoId = document.content.videoId
			this.query_document.content.kubun = document.content.kubun
			this.query_document.content.category = document.content.category
			this.query_document.content.player = document.content.player
			this.query_document.content.album = document.content.album
			this.query_document.content.createdAt = document.content.createdAt
			this.query_document.content.updatedAt = document.content.updatedAt

			this.changeSelectedCategory3()
		}
	}

	// ドキュメントの検索
	private changeSelectedCategory(): void {
		window.console.log("changeSelectedCategory() 1.this.selectedCategory: " + this.selectedCategory)
		this.document2s.forEach((doc, index) => {
			window.console.log("changeSelectedCategory() 2.index: " + index)
			window.console.log("changeSelectedCategory() 3.doc.docId: " + doc.docId)
			if (this.selectedCategory == doc.docId) {
				window.console.log("changeSelectedCategory() 4.doc.docId: " + doc.docId + ", index: " + index)
				this.menuCategoryIndex = index
				if (this.document2s[this.menuCategoryIndex].players.length > 0) {
					this.selectedPlayer = this.document2s[this.menuCategoryIndex].players[0]
				}
				//break
			}
		})
		this.changeSelectedPlayer()
	}

	
	// ドキュメントの登録
	private changeSelectedCategory2(): void {
		window.console.log("changeSelectedCategory2() 1.this.add_cdocument.ontent.category: " + this.add_document.content.category)
		this.document2s.forEach((doc, index) => {
			window.console.log("changeSelectedCategory2() 2.index: " + index)
			window.console.log("changeSelectedCategory2() 3.doc.docId: " + doc.docId)
			if (this.add_document.content.category == doc.docId) {
				window.console.log("changeSelectedCategory2() 4.doc.docId: " + doc.docId + ", index: " + index)
				this.categoryIndex2 = index
				if (this.document2s[this.menuCategoryIndex].players.length > 0) {
					this.add_document.content.player = this.document2s[this.menuCategoryIndex].players[0]
				}
			}
		})
		this.changeSelectedPlayer2()
	}

	// ドキュメントの更新
	private changeSelectedCategory3(): void {
		window.console.log("changeSelectedCategory3() 1.this.query_document.content.category: " + this.query_document.content.category)
		this.document2s.forEach((doc, index) => {
			window.console.log("changeSelectedCategory3() 2.index: " + index)
			window.console.log("changeSelectedCategory3() 3.doc.docId: " + doc.docId)
			if (this.query_document.content.category == doc.docId) {
				window.console.log("changeSelectedCategory3() 4.doc.docId: " + doc.docId + ", index: " + index)
				this.categoryIndex3 = index
				if (this.document2s[this.menuCategoryIndex].players.length > 0) {
					this.query_document.content.player = this.document2s[this.menuCategoryIndex].players[0]
				}
			}
		})
		this.changeSelectedPlayer3()
		/*
		//for (const [index, category] of this.categories) {
		this.categories.forEach((category, index) => {
			window.console.log("changeSelectedCategory3() 2.index: " + index)
			window.console.log("changeSelectedCategory3() 3.category.value: " + category.value)
			if (this.query_document.content.category == category.value) {
				window.console.log("changeSelectedCategory3() 4.category.value: " + category.value + ", index: " + index)
				this.categoryIndex3 = index
				if (this.categories[this.categoryIndex3].players.length > 0) {
					this.categories[this.categoryIndex3].players.forEach((player, index2) => {
						if (this.query_document.content.player == player.value) {
							this.playerIndex3 = index2
							this.query_document.content.player = this.categories[this.categoryIndex3].players[index2].text
						} // end of if
					}) // end of forEach
				}
				//break
			} // end of if
		}) // end of forEach
		this.changeSelectedPlayer3()
		*/
	}

	// ドキュメントの検索
	private changeSelectedPlayer(): void {
		window.console.log("changeSelectedPlayer() 1.this.selectedPlayer: " + this.selectedPlayer)
		this.document2s[this.menuCategoryIndex].players.forEach((player, index) => {
			window.console.log("changeSelectedPlayer() 2.index: " + index)
			window.console.log("changeSelectedPlayer() 3.player: " + player)
			if (this.selectedPlayer == player) {
				window.console.log("changeSelectedPlayer() 4.player: " + player + ", index: " + index)
				this.menuPlayerIndex = index
				///*
				if (this.document2s[this.menuCategoryIndex].category3.players[this.menuPlayerIndex].albums.length > 0) {
					this.selectedAlbum = this.document2s[this.menuCategoryIndex].category3.players[this.menuPlayerIndex].albums[0] 
				}
				//*/
				//break
			}			
		})
		this.changeSelectedAlbum()
	}

	// ドキュメントの登録
	private changeSelectedPlayer2(): void {
		window.console.log("changeSelectedPlayer2() 1.this.add_document.content.player: " + this.add_document.content.player)
		this.document2s[this.menuCategoryIndex].players.forEach((player, index) => {
			window.console.log("changeSelectedPlayer2() 2.index: " + index)
			window.console.log("changeSelectedPlayer2() 3.player: " + player)
			if (this.add_document.content.player == player) {
				window.console.log("changeSelectedPlayer2() 4.player: " + player + ", index: " + index)
				this.playerIndex2 = index
				if (this.document2s[this.categoryIndex2].category3.players[this.playerIndex2].albums.length > 0) {
					this.add_document.content.album = this.document2s[this.menuCategoryIndex].category3.players[this.menuPlayerIndex].albums[0] 
				}
			}
		})
		this.changeSelectedAlbum2()
		/*
		this.categories[this.categoryIndex2].players.forEach((player, index) => {
			window.console.log("changeSelectedPlayer2() 2.index: " + index)
			window.console.log("changeSelectedPlayer2() 3.this.add_document.content.player: " + this.add_document.content.player)
			window.console.log("changeSelectedPlayer2() 4.player.value: " + player.value)
			if (this.add_document.content.player == player.value) {
				window.console.log("changeSelectedPlayer2() 5.player.value: " + player.value + ", index: " + index)
				this.playerIndex2 = index
				if (this.categories[this.categoryIndex2].players[this.playerIndex2].albums.length > 0) {
					this.add_document.content.album = this.categories[this.categoryIndex2].players[this.playerIndex2].albums[0].text 
				}
				//break
			}			
		})
		this.changeSelectedAlbum2()
		*/
	}

	// ドキュメントの更新
	private changeSelectedPlayer3(): void {
		window.console.log("changeSelectedPlayer3() 1.this.query_document.content.player: " + this.query_document.content.player)
		//this.queryContentsProc()
	}

	// 使用していない
	private changeSelectedAlbum(): void {
		window.console.log("changeSelectedAlbum() 1.this.selectedAlbum: " + this.selectedAlbum)
		//this.queryContentsProc()
	}

	// 使用している	
	private changeSelectedAlbum2(): void {
		window.console.log("changeSelectedAlbum2() 1.this.add_document.content.album: " + this.add_document.content.album)
		//this.queryContentsProc()
	}

	// 「firestore」にプログラム的に新しいドキュメントを登録する
	public registerProc() {
		alert("生成機能は未サポートです")
		/*
		//const registerAlbum = this.dance_album_1
		//const registerAlbum = this.dance_album_2
		//const registerAlbum = this.karaoke_album_1
		//const registerAlbum = this.karaoke_album_2
		//const registerAlbum = this.karaoke_album_3
		//const registerAlbum = this.karaoke_album_4
		const registerAlbum = this.karaoke_album_5
		const url = registerAlbum.url
		window.console.log("registerProc() 1.url: " + url)
		const kubun = "music"
		window.console.log("registerProc() 2.kubun: " + kubun)
		//const category = "ダンス音楽"
		//const category = "カラオケ音楽（女性）"
		const category = "カラオケ音楽（男性）"
		window.console.log("registerProc() 3.category: " + category)
		const player = registerAlbum.player
		window.console.log("registerProc() 4.player: " + player)
		const album = registerAlbum.title
		window.console.log("registerProc() 5.album: " + album)
		registerAlbum.items.forEach((item, index) => {
			// name: string,
			this.add_document.content.name = item.title
			window.console.log("registerProc() 6.item.title: " + item.title)
			// videoId: string,
			const videoId = url + item.title + "." + item.type
			this.add_document.content.videoId = videoId
			window.console.log("registerProc() 7.videoId: " + videoId)
			// kubun: string,
			this.add_document.content.kubun = kubun
			// category: string,
			this.add_document.content.category = category
			// player: string,
			this.add_document.content.player = player
			// album: string,
			this.add_document.content.album = album
			// createdAt: string,
			this.add_document.content.createdAt = this.getStringFromDate(new Date())
			// updatedAt: string,
			this.add_document.content.updatedAt = this.getStringFromDate(new Date())
			let message = "name: " + this.add_document.content.name
			message += "\nvideoId: " + this.add_document.content.videoId
			message += "\nkubun: " + this.add_document.content.kubun
			message += "\ncategory: " + this.add_document.content.category
			message += "\nplayer: " + this.add_document.content.player
			message += "\nalbum: " + this.add_document.content.album
			message += "\ncreatedAt: " + this.add_document.content.createdAt
			message += "\nupdatedAt: " + this.add_document.content.updatedAt
			message += "\n\nの内容で登録しますか？"
			const ans = confirm(message)
			if (ans) {
				const contentsRef = this.$firestore.collection('contents')
				contentsRef.add(this.add_document.content)
				.then((docRef: any) => {
					const message = "Document written with ID: " + docRef.id
					this.addResult = message
					window.console.log("registerProc() 8." + message)
					this.add_document.content.name = ""
					this.add_document.content.videoId = ""
					this.add_document.content.album = ""
				})
				.catch((error: any) => {
					window.console.log("registerProc() 9.Error adding document: " + error)
				})
			}
		})
		*/
	}

  /** ライフサイクルフック */
  public created(){
	window.console.log("created() 1.")
	this.queryMenuProc()
	this.queryContentsProc('contents')
  }

}
